/**
 * Fair Game Sim uses individual inputs rather than a single params object.
 * Each preset maps input names to their values.
 */

export const FAIR_GAME_SIM_DEFAULT: Record<string, unknown> = {
  initialCost: 0.5,
  gameCount: 1000,
  batchSize: 50,
};

export const FAIR_GAME_SIM_HOUSE_FAVOURED: Record<string, unknown> = {
  initialCost: 0.7,
  gameCount: 1000,
  batchSize: 50,
};

export const FAIR_GAME_SIM_PLAYER_FAVOURED: Record<string, unknown> = {
  initialCost: 0.3,
  gameCount: 1000,
  batchSize: 50,
};

export const FAIR_GAME_SIM_PRESETS: Record<string, Record<string, unknown>> = {
  default: FAIR_GAME_SIM_DEFAULT,
  'house-favoured': FAIR_GAME_SIM_HOUSE_FAVOURED,
  'player-favoured': FAIR_GAME_SIM_PLAYER_FAVOURED,
};
